import * as a from '~js/utils/attributes';

export class TargetReferrer {
  constructor(el) {
    this.popupContainer = el;
    this.locationPath = location.href;

    if (!this.popupContainer.hasAttribute(a.attributes$b.targetReferrer)) {
      return false;
    }

    if (
      this.locationPath.indexOf(this.popupContainer.getAttribute(a.attributes$b.targetReferrer)) === -1 &&
      !window.Shopify.designMode
    ) {
      this.popupContainer.parentNode.removeChild(this.popupContainer);
    }
  }
}